"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "piozzano": {
    "c25179d3": [{
      "hkey": "c9a413b8",
      "slug": "piozzano",
      "name": "Piozzano",
      "primary": true,
      "skipSearch": false
    }],
    "groppo": [{
      "hkey": "c9a413b8",
      "slug": "piozzano",
      "name": "Piozzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a92a16c3": [{
      "hkey": "c9a413b8",
      "slug": "piozzano",
      "name": "Piozzano",
      "primary": true,
      "skipSearch": false
    }],
    "montecanino": [{
      "hkey": "c9a413b8",
      "slug": "piozzano",
      "name": "Piozzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "37b67432": [{
      "hkey": "c9a413b8",
      "slug": "piozzano",
      "name": "Piozzano",
      "primary": true,
      "skipSearch": false
    }],
    "monteventano": [{
      "hkey": "c9a413b8",
      "slug": "piozzano",
      "name": "Piozzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "13a4cdbf": [{
      "hkey": "c9a413b8",
      "slug": "piozzano",
      "name": "Piozzano",
      "primary": true,
      "skipSearch": false
    }],
    "pomaro": [{
      "hkey": "c9a413b8",
      "slug": "piozzano",
      "name": "Piozzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e4d49181": [{
      "hkey": "9f3ca8d1",
      "slug": "san-gabriele",
      "name": "San Gabriele",
      "primary": true,
      "skipSearch": false
    }],
    "san-gabriele-san-nazzaro": [{
      "hkey": "9f3ca8d1",
      "slug": "san-gabriele",
      "name": "San Gabriele",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;